<footer class="site-footer">

    <div class="container">

        <div class="row footer-main">

            <!-- About -->

            <div class="col-lg-5 col-md-12">

                <div class="footer-brand">

                    <h3>Get Your Vendor</h3>

                    <p>
                        India's Manufacturing Supplier Network connecting
                        buyers and manufacturers across machining,
                        casting, forging, fabrication, molding and
                        industrial sourcing.
                    </p>

                    <div class="footer-social">

                        <a class="linkedin"
                           href="https://www.linkedin.com/company/get-your-vendor"
                           target="_blank">
                            <i class="fa fa-linkedin"></i>
                        </a>

                        <a class="facebook"
                           href="https://www.facebook.com/gettyourvendor"
                           target="_blank">
                            <i class="fa fa-facebook"></i>
                        </a>

                        <a class="instagram"
                           href="https://www.instagram.com/getyourvendor/"
                           target="_blank">
                            <i class="fa fa-instagram"></i>
                        </a>

                        <a class="youtube"
                           href="https://www.youtube.com/@getyourvendor"
                           target="_blank">
                            <i class="fa fa-youtube"></i>
                        </a>

                    </div>

                </div>

            </div>

            <!-- Quick Links -->

            <div class="col-lg-3 col-md-6">

                <h4>Quick Links</h4>

                <ul class="footer-links">

                    <li><a routerLink="/blog">Blogs</a></li>

                    <li><a routerLink="/strategicpartner">
                        Partner Program
                    </a></li>

                    <li><a routerLink="/faq">
                        FAQs
                    </a></li>

                    <li><a routerLink="/privacy-policy">
                        Privacy Policy
                    </a></li>

                    <li><a routerLink="/terms">
                        Terms of Use
                    </a></li>

                </ul>

            </div>

            <!-- Company -->

            <div class="col-lg-4 col-md-6">

                <h4>Company</h4>

                <ul class="footer-links">

                    <li><a routerLink="/aboutus">About Us</a></li>

                    <li><a routerLink="/contactus">Contact Us</a></li>

                    <li><a routerLink="/vendorsbenefits">
                        Vendor Benefits
                    </a></li>

                    <li><a routerLink="/buyersbenefits">
                        Buyer Benefits
                    </a></li>

                    <li><a routerLink="/testimonials">
                        Success Stories
                    </a></li>

                    <li><a href="sitemap.xml">
                        Sitemap
                    </a></li>

                </ul>

            </div>

        </div>

    </div>

    <div class="footer-bottom">

        <div class="container">

            <div class="footer-bottom-content">

                <p>
                    © 2026 Indisourcing Solutions Pvt. Ltd.
                    All Rights Reserved.
                </p>

                <p>
                    Website Designed & Developed by
                    <a href="https://webispl.com"
                       target="_blank">
                        ISPL
                    </a>
                </p>

            </div>

        </div>

    </div>

</footer>